import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const getConsent = () => localStorage.getItem('cookie_consent');
export const setConsent = (value) => localStorage.setItem('cookie_consent', value);

const getSessionId = () => {
  let id = localStorage.getItem('ts_session_id');
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem('ts_session_id', id);
  }
  return id;
};

const getDevice = () => {
  const ua = navigator.userAgent;
  if (/tablet|ipad/i.test(ua)) return 'tablet';
  if (/mobi|android|iphone/i.test(ua)) return 'mobile';
  return 'desktop';
};

const getBrowser = () => {
  const ua = navigator.userAgent;
  if (ua.includes('Edg')) return 'Edge';
  if (ua.includes('OPR') || ua.includes('Opera')) return 'Opera';
  if (ua.includes('SamsungBrowser')) return 'Samsung';
  if (ua.includes('Chrome')) return 'Chrome';
  if (ua.includes('Safari')) return 'Safari';
  if (ua.includes('Firefox')) return 'Firefox';
  return 'Outro';
};

export const trackPageview = (path) => {
  if (getConsent() !== 'all') return;
  if (path.startsWith('/admin')) return;
  const params = new URLSearchParams(window.location.search);
  axios.post(`${API}/analytics/track`, {
    session_id: getSessionId(),
    path,
    referrer: document.referrer || '',
    utm_source: params.get('utm_source'),
    utm_medium: params.get('utm_medium'),
    utm_campaign: params.get('utm_campaign'),
    device: getDevice(),
    browser: getBrowser(),
    screen_width: window.screen?.width,
    language: navigator.language,
  }).catch(() => {});
  if (window.gtag) window.gtag('event', 'page_view', { page_path: path });
};

let ga4Loaded = false;
export const initGA4 = async () => {
  if (ga4Loaded || getConsent() !== 'all') return;
  try {
    const res = await axios.get(`${API}/settings/ga4_id`);
    const id = res.data?.value;
    if (!id) return;
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', id, { anonymize_ip: true });
    ga4Loaded = true;
  } catch (e) { /* silencioso */ }
};
